import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../utils/lang_provider";
import { fetchData } from "../../utils/fetch";

export default function WebObjects() {
  const [positions, setPositions] = useState([]);
  const [webObjects, setWebObjects] = useState([]);
  const { language } = useContext(LanguageContext)
  
  useEffect(() => {
    async function loadPositions() {
        try {
            const data = await fetchData(`admin/positions`, language);
            setPositions(data);
        } catch (error) {
            console.error('Error loading positions:', error);
        }
    }
    async function loadWebObjects() {
        try {
            const data = await fetchData(`front/web-objects`, language);
            setWebObjects(data);
        } catch (error) {
            console.error('Error loading web objects:', error);
        }
    }
    loadPositions();
    loadWebObjects();
  }, [language]);

  return (
    <div className="web-objects">
      {positions.map(item => (
        <div className="positions">
          <h1>{item.title}</h1>
          <ul>
            {webObjects.filter(object => object.position === item.position).map(object => (
              <li>
                <h2>{object.title}</h2> 
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )

}